window.directives = window.directives || ['LocalStorageModule', 'ngSanitize', 'firebase'];
window.app = angular.module('app', window.directives).directive('offClick', ['$document', "$parse", "$timeout", function ($document, $parse, $timeout) {
    return {
        restrict: 'A',
        compile: function (tElement, tAttrs) {
            var fn = $parse(tAttrs.offClick);
            var listAllowed = 'no-autoclose';
            return function (scope, iElement, iAttrs) {
                function eventHandler(ev) {
                    var elem = $(ev.target);
                    if (iElement[0].contains(ev.target) || elem.hasClass(listAllowed)) {
                        $document.one('click touchend', eventHandler);
                    } else {
                        scope.$apply(function () {
                            fn(scope);
                        });
                    }
                }
                scope.$watch(iAttrs.offClickActivator, function (activate) {
                    if (activate) {
                        $timeout(function () {
                            $document.one('click touchend', eventHandler);
                        });
                    } else {
                        $document.off('click touchend', eventHandler);
                    }
                });
            };
        }
    }
}]).directive('lazyLoad', lazyLoad).directive("bnLazySrc", ["$window", "$document", function ($window, $document) {

    var lazyLoader = (function () {

        var images = [];
        var renderTimer = null;
        var renderDelay = 100;
        var win = $($window);
        var doc = $document;
        var documentHeight = doc.height();
        var documentTimer = null;
        var documentDelay = 2000;
        var isWatchingWindow = false;

        function addImage(image) {
            images.push(image);
            if (!renderTimer) {
                startRenderTimer();
            }

            if (!isWatchingWindow) {
                startWatchingWindow();
            }
        }


        function removeImage(image) {
            for (var i = 0; i < images.length; i++) {
                if (images[i] === image) {
                    images.splice(i, 1);
                    break;
                }

            }

            if (!images.length) {
                clearRenderTimer();
                stopWatchingWindow();
            }

        }


        function checkDocumentHeight() {

            if (renderTimer) {
                return;
            }

            var currentDocumentHeight = doc.height();
            if (currentDocumentHeight === documentHeight) {
                return;
            }
            documentHeight = currentDocumentHeight;
            startRenderTimer();

        }

        function checkImages() {

            var visible = [];
            var hidden = [];
            var windowHeight = win.height();
            var scrollTop = win.scrollTop();
            var topFoldOffset = scrollTop;
            var bottomFoldOffset = (topFoldOffset + windowHeight);

            for (var i = 0; i < images.length; i++) {
                var image = images[i];
                if (image.isVisible(topFoldOffset, bottomFoldOffset)) {
                    visible.push(image);
                } else {
                    hidden.push(image);
                }
                
            }

            for (var i = 0; i < visible.length; i++) {

                visible[i].render();

            }
            images = hidden;
            clearRenderTimer();
            if (!images.length) {
                stopWatchingWindow();
            }

        }

        function clearRenderTimer() {
            clearTimeout(renderTimer);
            renderTimer = null;

        }

        function startRenderTimer() {
            renderTimer = setTimeout(checkImages, renderDelay);
        }


        function startWatchingWindow() {

            isWatchingWindow = true;
            win.on("resize.bnLazySrc", windowChanged);
            win.on("scroll.bnLazySrc", windowChanged);
            documentTimer = setInterval(checkDocumentHeight, documentDelay);

        }


        function stopWatchingWindow() {
            isWatchingWindow = false;
            win.off("resize.bnLazySrc");
            win.off("scroll.bnLazySrc");
            clearInterval(documentTimer);

        }


        function windowChanged() {
            if (!renderTimer) {
                startRenderTimer();
            }

        }

        return ({
            addImage: addImage,
            removeImage: removeImage
        });

    })();


    function LazyImage(element) {
        
        var source = null;
        var isRendered = false;
        var height = null;

        previewHotelImage(element[0]);
        function isVisible(topFoldOffset, bottomFoldOffset) {

            if (!element.is(":visible")) {

                return (false);

            }

            if (height === null) {

                height = element.height();

            }

            var top = element.offset().top;
            var bottom = (top + height);

            return (
                (
                    (top <= bottomFoldOffset) &&
                    (top >= topFoldOffset)
                )
                ||
                (
                    (bottom <= bottomFoldOffset) &&
                    (bottom >= topFoldOffset)
                )
                ||
                (
                    (top <= topFoldOffset) &&
                    (bottom >= bottomFoldOffset)
                )
            );

        }

        function render() {
            isRendered = true;
            renderSource();

        }

        function setSource(newSource) {
            source = newSource;
            if (isRendered) {
                renderSource();
            }

        }

        function renderSource() {

            element[0].onerror = () => {
                previewHotelImage(element[0], /*imageFailer = */ true)
            }
            
            element[0].src = source;
            if (window.__pt.renderLazyload) {
                window.__pt.renderLazyload(element[0]);
            }

        }

        return ({
            isVisible: isVisible,
            render: render,
            setSource: setSource
        });

    }
    
    function previewHotelImage(image, imageFailed = false) {
        if((image.classList[0] === "hotel-card-img" && !image.src) || imageFailed) {
            image.src = window.__pt.settings.site.cloudCdn + `/assets/img/placeholder_img_${window.__pt.settings.site.country}.png`;
        }
    }

    function link($scope, element, attributes) {

        var lazyImage = new LazyImage(element);
        lazyLoader.addImage(lazyImage);

        attributes.$observe(
            "bnLazySrc",
            function (newSource) {

                lazyImage.setSource(newSource);

            }
        );

        $scope.$on(
            "$destroy",
            function () {

                lazyLoader.removeImage(lazyImage);

            }
        );

    }

    return ({
        link: link,
        restrict: "A"
    });

}]);

function lazyLoad() {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            const observer = new IntersectionObserver(loadImg)
            const img = angular.element(element)[0];
            observer.observe(img)

            function loadImg(changes) {
                changes.forEach(change => {
                    if (change.intersectionRatio > 0) {
                        change.target.src = change.target.getAttribute('data-src')
                        observer.unobserve(change.target);
                    }
                })
            }

        }
    }
}

window.app.config(['$locationProvider', function ($locationProvider) {
    $locationProvider.html5Mode({ enabled: true, requireBase: false, rewriteLinks: false });
}])

window.app.config(["localStorageServiceProvider", function (localStorageServiceProvider) {
    localStorageServiceProvider
        .setPrefix('pt');
}]);


window.app.filter("asDate", function () {
    return function (input) {
        return window.__pt.fn.getDate(input);
    }
});

window.app.filter("roundToInt", function () {
    return function (input) {
        return Math.round(input);
    }
})

window.app.filter("resizeString", function () {
    return function (input, limit, toggle) {
        if (input.length <= limit)
            return input;

        return toggle ? input.substring(0, limit) + '...' : input;
    }
})

window.app.directive("inViewport", function () {
    return {
        scope: {
            fn: "&inViewport",
        },
        restrict: "A",
        link: function (scope, element, attrs) {
            const observer = new IntersectionObserver(callback);

            const item = angular.element(element)[0];
            observer.observe(item);

            function callback(changes) {
                changes.forEach(change => {
                    scope.fn({ event: { isVisible: change.isIntersecting, element: item } });
                });
            }
        }
    };
});
window.app.filter("getIconStars", function () {
    return function (input) {
        return `icon-${Math.floor(input)}${input % 1 == 0 ? "-" : "-half-"}star`;
    }
});

window.app.filter("getRatingDesc", function () {
    return function (input) {
        let total = input * 2;
        let ratings = __pt.ln.rating_reviews_range;


        for (let i = 0; i < ratings.length; i++) {
            if (total >= ratings[i].range[0] && total <= ratings[i].range[1]) {
                return ratings[i].display;
            }

        }
    }
});


window.app.filter("highlights", function () {
    return function (input) {
        let hl = input.slice(0, 3).map(h => h.info);
        return hl.join(" \n\u2022 ");
    }
});

window.app.filter("getUrlDetail", function () {
    return function (uri) {
        return window.__pt.settings.site.siteUrl + '/hotel/' + uri + window.location.search;
    }
});

window.app.filter("paginationRange", function () {
    return function (pagination, text) {
        const range = {
            from: pagination.currentPage * pagination.pageSize,
            to: (pagination.currentPage + 1) * pagination.pageSize,
            of: pagination.totalHotels
        }
        return text.replace('(from)', range.from + 1).replace('(to)', (range.to >= range.of ? range.of : range.to)).replace('(total)', range.of);
    }
});
window.app.filter('commanseparatecolo', [
    function () {// should be altered to suit your needs
        return function (input) {
            var ret = (input) ? input.toString().replace(".", ",") : null;
            if (ret) {
                var decArr = ret.split(",");
                if (decArr.length > 1) {
                    var dec = decArr[1].length;
                    if (dec === 1) { ret += "0"; }
                }//this is to show prices like 12,20 and not 12,2
            }
            return ret;
        };
    }]);

window.app.filter('capitalize', function() {
    return function(input) {
        if (!input) return '';
        return input.charAt(0).toUpperCase() + input.slice(1).toLowerCase();
    };
});
window.app.filter('orderObjectByKey', function() {
    return function(items, reverse) {
        if (!items) return [];
        
        const filtered = [];
        angular.forEach(items, function(item, key) {
            filtered.push({ key: Number(key), value: item });
        });
        
        filtered.sort(function(a, b) {
            return a.key - b.key;
        });

        if (reverse) filtered.reverse();
        return filtered;
    };
});


window.app.filter('tel', function () {
    return function (tel) {
        if (!tel) { return ''; }

        var value = tel.toString().trim().replace(/^\+/, '');

        if (value.match(/[^0-9]/)) {
            return tel;
        }

        var country, city, number;

        switch (value.length) {
            case 10:
                country = 1;
                city = value.slice(0, 2);
                number = value.slice(2);
                break;

            case 11:
                country = value[0];
                city = value.slice(1, 4);
                number = value.slice(4);
                break;

            case 12:
                country = value.slice(0, 3);
                city = value.slice(3, 5);
                number = value.slice(5);
                break;

            default:
                return tel;
        }

        if (country == 1) {
            country = "";
        }

        number = number.slice(0, 4) + ' ' + number.slice(4);

        return (country + " " + city + " " + number).trim();
    };
})

window.app.filter("capacityString", function () {
    return function (input) {
        return window.__pt.ln.capacity.replace('{0}', input) + (input > 0 && 's');
    }
});

window.app.filter("capitalize", function () {
    return function (input) {
        return input.charAt(0).toUpperCase() + input.slice(1);
    }
});

window.app.filter("kidsAgeRange", function () {
    return function (input) {
        return window.__pt.ln.kidsFreeTo.replace('{0}', input);
    }
});

window.app.filter("setSizeParams", function () {
    return function (imageUri) {
        const screenSizes = window.__pt.settings.screenSizes;
        const { mediaQueryDesktop, mediaQueryTablet, mediaQuerySmall, mediaQueryMobile } = window.__pt.fn.mediaQueries(screenSizes);

        if (mediaQueryDesktop().matches) {
            return '?tx=w_552,h_368';
        }

        if (mediaQueryTablet().matches) {
            return '?tx=w_464,h_309';
        }

        if (mediaQuerySmall().matches) {
            return '?tx=w_464,h_309';
        }

        if (mediaQueryMobile().matches) {
            return '?tx=w_390';
        }

        return '?tx=w_390';
    }
})

window.app.filter("separateHistory", function () {
    return function (input) {
        const split = input.split(' - ');
        if (split.length === 2) {
            return `
                <span><b>${split[0]}</b></span>
                <div><small>${split[1]}</small></div>
            `;
        }

        return input;
    }
});

window.app.filter("singularize", function () {
    return function (input, number, breakpoint = 1) {

        if (number > 1) {
            return input;
        } else {
            return input.substring(0, input.length - breakpoint);
        }
    }
});

window.app.filter("andmsi", function () {
    return function (paymentPlans = [], separator, text) {

        if (!paymentPlans.length) {
            return "";
        }

        let string = paymentPlans[0] + " msi*";

        if (paymentPlans.length > 1) {
            string = paymentPlans.slice(0, paymentPlans.length - 1).join(", ") + ` ${separator} ` + paymentPlans.slice(-1)[0] + " " + text;
        }

        return string;
    }
});

window.app.filter('removeSpaces', [function () {
    return function (string) {
        if (!angular.isString(string)) {
            return string;
        }
        return string.replace(/[\s]/g, '');
    };
}])

window.app.filter('cityScpecialChar', [function () {
    return function (string) {

        const words = {
            "Bogota": "Bogot�"
        };

        if (words[string]) {
            return words[string];
        }

        return string;
    };
}])

window.app.filter('pluralize', [function () {
    return function (string, quantity, suffix) {
        if (quantity > 1) {
            return (string + suffix);
        }
        return string;
    };
}])

window.app.filter('orderByMaxItem', [function () {
    return function (arr, property = []) {
        return arr.sort((a, b) => {
            const max = arr => Math.max.apply(null, arr);
            if (max(a[property]) < max(b[property])) {
                return 1;
            }
            if (max(a[property]) > max(b[property])) {
                return -1;
            }
            return 0;
        })
    };
}])

window.app.filter("replace", function () {
    return function (input, simbol, tosimbol) {

        return input.replace(simbol, tosimbol);
    }
})

window.app.filter('filter_titles', [function () {
    return function (string) {

        let titles = window.__pt.ln.overriteTitles;

        return titles[string.replaceAll(" ", "")] ? titles[string] : string;
    };
}])